import axios from 'axios';
import { ShipmentData, dbOperations } from '../lib/supabase';

const API_KEY = import.meta.env.VITE_TERMINAL49_API_KEY;
const BASE_URL = 'https://api.terminal49.com/v2';

interface Terminal49Response {
  data: Array<{
    id: string;
    type: string;
    attributes: {
      bill_of_lading_number: string;
      shipping_line_name: string;
      customer_name: string;
      port_of_lading_name: string;
      port_of_discharge_name: string;
      pod_vessel_name: string;
      pod_voyage_number: string;
      pol_atd_at: string | null;
      pod_eta_at: string | null;
      pod_ata_at: string | null;
    };
    relationships: {
      containers: {
        data: Array<{ id: string; type: string }>;
      };
    };
  }>;
}

export async function fetchShipments(): Promise<Omit<ShipmentData, 'created_at'>[]> {
  try {
    const response = await axios.get<Terminal49Response>(`${BASE_URL}/shipments`, {
      headers: {
        'Authorization': `Bearer ${API_KEY}`,
        'Accept': 'application/json'
      }
    });

    return response.data.data.map(shipment => ({
      id: shipment.id,
      bl_number: shipment.attributes.bill_of_lading_number,
      shipping_line: shipment.attributes.shipping_line_name,
      customer: shipment.attributes.customer_name,
      origin: shipment.attributes.port_of_lading_name,
      destination: shipment.attributes.port_of_discharge_name,
      vessel: shipment.attributes.pod_vessel_name,
      voyage: shipment.attributes.pod_voyage_number,
      departure_date: shipment.attributes.pol_atd_at,
      estimated_arrival: shipment.attributes.pod_eta_at,
      actual_arrival: shipment.attributes.pod_ata_at,
      container_count: shipment.relationships.containers.data.length,
      last_updated: new Date().toISOString()
    }));
  } catch (error) {
    console.error('Terminal49 API Error:', error);
    throw error;
  }
}

export async function fetchAndStoreShipments(): Promise<void> {
  try {
    const shipments = await fetchShipments();
    await dbOperations.storeShipments(shipments);
  } catch (error) {
    console.error('Error fetching and storing shipments:', error);
    throw error;
  }
}

export async function getStoredShipments(): Promise<ShipmentData[]> {
  try {
    return await dbOperations.getShipments();
  } catch (error) {
    console.error('Error getting stored shipments:', error);
    throw error;
  }
}